import DefaultApiService from "./default";

const CustomerPriceOfferContractApi = {
  getPriceConfirmationWorkspace: async (requestId) => {
    try {
      const res = await DefaultApiService.getCustomeApi(
        `SLN/Customer/CustomerPriceOffers/GetPriceConfirmationWorkspace?requestId=${requestId}`
      );
      return {
        ok: res?.isSuccess !== false,
        message: res?.message || "",
        data: res?.data,
        statusCode:
          res?.statusCode != null
            ? res.statusCode
            : res?.isSuccess !== false
              ? 200
              : 400,
      };
    } catch (error) {
      return {
        ok: false,
        message:
          error?.response?.data?.message ||
          error?.message ||
          "خطا در دریافت workspace تأیید قیمت",
        data: null,
        statusCode: error?.response?.status ?? null,
      };
    }
  },

  getOfferForCustomer: async (requestId) => {
    const res = await DefaultApiService.getCustomeApi(
      `SLN/Customer/CustomerPriceOffers/GetOfferForCustomer?requestId=${requestId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },

  acceptOfferByCustomer: async (payload) => {
    const res = await DefaultApiService.postApi(
      "SLN/Customer/CustomerPriceOffers/AcceptOfferByCustomer",
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },

  rejectOfferByCustomer: async (payload) => {
    const res = await DefaultApiService.postApi(
      "SLN/Customer/CustomerPriceOffers/RejectOfferByCustomer",
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },

  markContractDownloaded: async (requestId) => {
    const res = await DefaultApiService.postApi(
      `SLN/Customer/CustomerContractAcceptance/MarkContractDownloaded?requestId=${requestId}`,
      {}
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },

  uploadSignedCustomerContract: async (payload) => {
    const res = await DefaultApiService.postApi(
      "SLN/Customer/CustomerContractAcceptance/UploadSignedCustomerContract",
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },
};

export default CustomerPriceOfferContractApi;
